import { datadogRum } from '@datadog/browser-rum'
import { DatadogInitOptions, DatadogGlobalContext } from './types'


/**
 * Initialize Datadog RUM with provided configuration
 * @param options - Datadog initialization options
 * @param globalContext - Optional global context to attach to required events (mainly for hcp as microsite and hcp are in same ecrm-ui)
 */
export const initDatadog = (
  options: DatadogInitOptions,
  globalContext?: DatadogGlobalContext
) => {

  datadogRum.init({
    applicationId: options.applicationId,
    clientToken: options.clientToken,
    site: options.site ?? 'us5.datadoghq.com',
    service: options.service,
    env: options.env,
    version: options.version ?? '6.27.0',
    sessionSampleRate: options.sessionSampleRate ?? 100,
    sessionReplaySampleRate: options.sessionReplaySampleRate ?? 20,
    trackBfcacheViews: options.trackBfcacheViews ?? true,
    defaultPrivacyLevel: options.defaultPrivacyLevel ?? 'mask-user-input',
    trackingConsent: options.trackingConsent ?? 'granted',
    storeContextsAcrossPages: options.storeContextsAcrossPages ?? true,
    trackSessionAcrossSubdomains: options.trackSessionAcrossSubdomains ?? true,
  })

  if (globalContext) {
    datadogRum.setGlobalContext(globalContext)
  }

}

export const stopDatadog = () => {
  datadogRum.stopSession()
}

export const setDatadogContext = (context: DatadogGlobalContext) => {
  datadogRum.setGlobalContext(context)
}